
import React from 'react';
import { ContactHeader } from './contact/ContactHeader';
import { ContactCard } from './contact/ContactCard';

const ContactSection = () => {
  return (
    <section id="contact" className="py-16 px-6 bg-gradient-to-br from-sage-100 via-sage-50 to-white">
      <div className="container max-w-5xl mx-auto text-center">
        <ContactHeader />
        <ContactCard />
      </div>
    </section>
  );
};

export default ContactSection;
